import module from 'fan/proyecto/module.js'

module.config(($stateProvider) => {
    $stateProvider.state('proyecto.colaboradores.creditos.fonacot', {
      url: '/fonacot',
      data: {title: 'Crédito FONACOT'},
      template: '<fan-proyecto-colaboradores-creditos-fonacot proyecto-id="idProyecto"/>',
      controller: ($scope, idProyecto) => {
        $scope.idProyecto = idProyecto
      },
    })
  },
)



// WEBPACK FOOTER //
// ./src/fan/proyecto/routes/proyecto/colaboradores/creditos/fonacot.js